module.exports = __webpack_public_path__ + "static/img/imagePe.ef28a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/imagePe.png
// module id = gRhK
// module chunks = 63